import { ICreatorMockData, createMockCreator } from '~/creatorMockUtils';

const mockCreatorEmptyTalentPage: ICreatorMockData[] = [
  {
    age: 25,
    avatar:
      'https://framerusercontent.com/images/GDeqpWcDtOgLMC2r4j5u5CAvs.jpg?scale-down-to=512',
    bio: "Andrea is wholeheartedly dedicated to her career in the arts and humanities. Her passions encompass literature, the intricacies of fine art, the simple pleasure of coffee, maintaining their fitness and health, and the sheer delight of a meticulously curated garden 🌻🌿. She enjoys indulging in quaint cafés ☕, exploring bookshops 📚🏫, and taking leisurely strolls along cobblestone streets that echo the city's rich history 🏰🚶 and keeping fit.",
    category: 'Comedy,LGBTQ+,Lifestyle',
    gender: 'Female',
    fullName: 'Andrea Michaels',
    city: 'England',
    status: 'connected',
    platform: {
      instagram: {
        followersCount: 17500,
        handle: 'andreamichaels',
      },
      snapchat: {
        followersCount: 23000,
        handle: 'andreamichaels',
      },
    },
    weblink: ['https://soundcloud.com/', 'https://www.twitch.tv/'],
    contentAgencyMockPost: [
      'https://framerusercontent.com/images/uc587LYKxkx85uf6HhCIxAFYz80.jpg',
      ' https://framerusercontent.com/images/HFDcX94NtXY5IdvtgaJ55T25o.jpg',
      'https://framerusercontent.com/images/j11E1qkK8lBKOkfVjWZFsX9Tqg.jpg',
      'https://framerusercontent.com/images/9oWNZ9YX1hPO1DDeFLEVdmNkoJE.jpg?scale-down-to=2048',
      'https://framerusercontent.com/images/LFSSUqotrdA1gHEjX3guO47Gss.jpg',
      'https://framerusercontent.com/images/nxgzSiYvb8VGZCf3tQbgifMOy8s.jpg',
      'https://framerusercontent.com/images/FONdrOJNI9ddZKyEKS6Wd2pj2Sk.jpg?scale-down-to=512',
    ],
  },
  {
    age: 23,
    avatar:
      'https://user-assets.dev.usefoam.com/d748183f-3c1e-44c2-b050-87a36e9c45fb/creator-logo/blob-668649f5c2dc55-27308523.png',
    bio: "In the picturesque city of Paris, Aria thrives in a career that harmoniously combines creativity with social impact. They hold the position of a director of an arts program or serve as a cultural ambassador. A true aficionado of the arts, they invest their time attending gallery openings, immersing themselves in cultural events, and finding solace in the tranquil corners of the city's cafés. Their passion for travel is evident, seizing every opportunity to explore new destinations and collect stories to share within their community.",
    category: 'Beauty,Comedy,Travel',
    gender: 'Female',
    fullName: 'Aria Bennett',
    city: 'Paris',
    status: 'connected',
    platform: {
      instagram: {
        followersCount: 127100,
        handle: 'ariabennett',
      },
    },
    contentAgencyMockPost: [
      'https://framerusercontent.com/images/dPnkARXau1uc1nAL03YJkHwMM.jpg',
      'https://framerusercontent.com/images/ktSp9Lbvn8rujCQJyw1bcRSgFM.jpg?scale-down-to=512',
      'https://framerusercontent.com/images/DKwieNdpcbpeKgInrBjCoGFVI.jpg',
      'https://framerusercontent.com/images/4Sn96N5dC9eTHsZnQzXPFBqit0.jpg',
      'https://framerusercontent.com/images/Y5xEgbcRBdW3orw6LvrExN9ajcQ.jpg?scale-down-to=4096',
      'https://framerusercontent.com/images/IwSfzgzYge79XbhNDmMWlN0oqm4.jpg',
      'https://framerusercontent.com/images/yhhFJJjTY826UmbPhJRmlP5wnI.jpg',
    ],
  },
  {
    age: 37,
    avatar:
      'https://user-assets.dev.usefoam.com/c8b2ff09-330a-45e8-b50e-d022f2077aed/creator-logo/blob-66864abc026505-55403310.png',
    bio: "Mostly cheerful and calm, Ethan Carter radiates contentment with their life's path. They reside in a mid-sized town, where they run their own business in community services, providing them with ample opportunities to interact with a diverse range of people. Their interests span outdoor activities, craft beers, and live music. Valuing community deeply, they frequently volunteer for local events and charity organizations. They find solace in nature trails, relish moments at a local brewery with friends, and savor backyard barbecues with their ext",
    category: 'Travel,Food,Family',
    gender: 'Male',
    fullName: 'Ethan Carter',
    city: 'Doha',
    status: 'connected',
    platform: {
      instagram: {
        followersCount: 127100,
        handle: 'ethancarter',
      },
      tiktok: {
        followersCount: 2700000,
        handle: 'ethancarter',
      },
      youtube: {
        followersCount: 22600,
        handle: 'ethancarter',
      },
    },
    contentAgencyMockPost: [
      'https://framerusercontent.com/images/IMjOLBO1SYu7iZJ6m2XJ59aIQU.jpg',
      'https://framerusercontent.com/images/MqUAaNvaw7VhnIqXpnaim5ytN7g.jpg?scale-down-to=512',
      'https://framerusercontent.com/images/43XD9fE0DjPM62eTkXoizoS6M.jpg?scale-down-to=4096',
      'https://framerusercontent.com/images/FZrNqcoyVpk7yaeWMWTVpH0b8eQ.jpg',
      'https://framerusercontent.com/images/TdRvKjbQ0hKyTO9z5ytXurWRYk.jpg',
      'https://framerusercontent.com/images/CTpiKGELJ2uNPaO3YMC2RZoRK0.jpg',
      'https://framerusercontent.com/images/VVISlgKTEDTztrh3cOeXGF7X3vM.jpg',
    ],
  },
  {
    age: 24,
    avatar:
      'https://user-assets.dev.usefoam.com/cf9cecb0-84a8-43ec-bc9d-2356e4707027/creator-logo/blob-6686498d864077-65382038.png',
    bio: 'Confident and charismatic, Jake Harrison exudes an unmistakable presence. New York City is their home, and they harbor aspirations for a career in modeling, acting, or music. Their passions revolve around fitness, music, and the vibrant urban nightlife, where they thrive on socializing and staying active within the bustling city scene.',
    category: 'Mental Health,Fitness,Sport',
    gender: 'Male',
    fullName: 'Jake Harrison',
    city: 'Paris',
    status: 'connected',
    platform: {
      instagram: {
        followersCount: 362100,
        handle: 'jakeharrison',
      },
    },
    contentAgencyMockPost: [
      'https://framerusercontent.com/images/Z6l67maKG9JB7GzJPokGrwxwhoM.jpg',
      'https://framerusercontent.com/images/XWdMTfO7Jcoc5Vl8VsnQbdsyQKE.jpg',
      'https://framerusercontent.com/images/vONJRcDiOdig242Q3TiVm6E4.jpg',
      'https://framerusercontent.com/images/i8mVUwm14Wzcj9wkVgGiwWzkGxU.jpg',
      'https://framerusercontent.com/images/i7KqDUXy7NCRsTug1kWzWzsE.jpg?scale-down-to=1024',
      'https://framerusercontent.com/images/BTrWwhmTuq4Fjn5Y0zr3EySOUhk.jpg',
      'https://framerusercontent.com/images/aRXliDWovgOYXMjbXY1nxDqfSoQ.jpg',
    ],
  },
  {
    age: 27,
    avatar:
      'https://user-assets.dev.usefoam.com/0da9f51f-396b-4151-9d51-ae15632d3fd7/creator-logo/blob-66864865658a82-10584065.png',
    bio: "John Macmillan resides in vibrant San Francisco, where he's an entrepreneur in the tech industry. His work bridges technology and art, prioritizing innovation and creativity. John keeps tabs on tech trends, balancing it with his love for the outdoors, photography, and city gastronomy. He actively engages in forums discussing urban living's future. With over 7.9 million dedicated followers, he finds inspiration in diverse ideas shaping our evolving world.",
    category: 'Education,Beauty,Fitness',
    gender: 'Male',
    fullName: 'John Macmillan',
    city: 'San Francisco',
    status: 'connected',
    platform: {
      instagram: {
        followersCount: 977800,
        handle: 'johnmacmillan',
      },
      tiktok: {
        followersCount: 7900,
        handle: 'johnmacmillan',
      },
      youtube: {
        handle: 'johnmacmillan',
        followersCount: 9400,
      },
    },
    contentAgencyMockPost: [
      'https://framerusercontent.com/images/WmqXDzeU6HYWB8JvUFJ9dmiDII.jpg?scale-down-to=512',
      'https://framerusercontent.com/images/WjHMOIvXqgkm6Pzm0QEC6ikkegI.jpg?scale-down-to=1024',
      'https://framerusercontent.com/images/IJfgX6GKPmPtbuGSK1zYPYilv4.jpg?scale-down-to=512',
      'https://framerusercontent.com/images/ij8toJVe1WG40qI4IeEKufpCctE.jpg?scale-down-to=512',
      'https://framerusercontent.com/images/QRsMdu8yduI9ji8VJufQPsvUfU.jpg',
      'https://framerusercontent.com/images/lNylP8lbzytsEYodGknxAG4WRuw.jpg?scale-down-to=1024',
      'https://framerusercontent.com/images/mtWCQ7oodqruNCUqANzLicbc.png',
    ],
  },
  {
    age: 28,
    avatar:
      'https://user-assets.dev.usefoam.com/246f8810-0012-4a46-bcdf-6eeb0d0b7d94/creator-logo/blob-66864b157a5c64-91586198.png',
    bio: 'In the busy metropolitan city of Shanghai, Mei Lin works as a fashion designer for a well-known sports brand. Outside their professional pursuits, they are a connoisseur of contemporary art and enjoy exploring the urban landscape with their vintage DSLR camera. They highly value sustainability and innovation, often participating in events that champion these important causes.',
    category: 'Beauty,Education,Fitness',
    gender: 'Female',
    fullName: 'Mei Lin',
    status: 'connected',
    city: 'Hong Kong',
    platform: {
      instagram: {
        handle: 'meilin',
        followersCount: 208800,
      },
      youtube: {
        handle: 'meilin',
        followersCount: 1000000,
      },
    },
    contentAgencyMockPost: [
      'https://framerusercontent.com/images/fiYBSjeclrYlWHJWCYRWDZV30.jpg',
      'https://framerusercontent.com/images/t481pgP8WWj9pB731M5fC2sdYpw.jpg?scale-down-to=512',
      'https://framerusercontent.com/images/bKlT1XyOGe1ilfFLuyi694zTkc.jpg?scale-down-to=1024',
      'https://framerusercontent.com/images/yqeP3du3CNEqLLWf9fMsPaZ1KY.webp',
      'https://framerusercontent.com/images/v7uF5HXN69oJ5g2GttW8D75S08.jpg?scale-down-to=4096',
      'https://framerusercontent.com/images/kVJHc6jFST9LSkj3nquDvrIi8.jpg',
      'https://framerusercontent.com/images/pqHHK6zaPzJuAABbCLUl6AzVWxc.jpg',
    ],
  },
  {
    age: 29,
    avatar:
      'https://user-assets.dev.usefoam.com/72ca122c-42a3-4d1a-8c64-4fef1a5109f0/creator-logo/blob-668638dfd9de95-00851663.png',
    bio: "Hailing from the stunning city of Miami, this individual is an artist at heart, finding endless inspiration in the city's vibrant panorama 🌆. A passionate lover of the arts 🎨📷, their talents span from photography to painting 🖼️, and they dedicate their creativity to community art programs 🎨🏫. Deeply rooted in their heritage 🌴🌺, they actively participate in cultural festivals 🎉🎊 and advocate for educational programs in their community 📚👩‍🏫. When not engaged in their art, they find solace in the rhythmic waves of the nearby sea 🌊",
    category: 'Beauty,Fashion,Lifestyle',
    gender: 'Female',
    fullName: 'Natalia Diaz',
    status: 'connected',
    city: 'Miami',
    platform: {
      instagram: {
        handle: 'nataliadiaz',
        followersCount: 120400,
      },
      tiktok: {
        handle: 'nataliadiaz',
        followersCount: 12600,
      },
      youtube: {
        followersCount: 23300,
        handle: 'nataliadiaz',
      },
      snapchat: {
        followersCount: 57800,
        handle: 'nataliadiaz',
      },
    },
    contentAgencyMockPost: [
      'https://framerusercontent.com/images/8v6FPIC7X5Ek0wCZhRYmnrlHpo.jpg?scale-down-to=512',
      'https://framerusercontent.com/images/GwujNBySzYdorEvrxMBlxAuAMAU.jpg?scale-down-to=1024',
      'https://framerusercontent.com/images/8q8qIsDpe8TCkLlOYIXgN4bk3ow.jpg',
      'https://framerusercontent.com/images/ccpBk4D3QRYOe1zHUN3yOfvwkU.jpg?scale-down-to=512',
      'https://framerusercontent.com/images/3XJrjT4ji5W4PTUb56LaqBAqvvg.jpg?scale-down-to=512',
      'https://framerusercontent.com/images/oFCxX3uQyFa8OPiJRNFJdLa0XPA.jpg',
      'https://framerusercontent.com/images/KyTrPxsrZXLpw4sgv3Cd42UUdL8.jpg',
    ],
  },
  {
    age: 23,
    avatar:
      'https://user-assets.dev.usefoam.com/e5aa8ade-fa07-40ae-880c-595c9ac0f919/creator-logo/blob-668648e48223c6-10068857.png',
    bio: "Graceful and composed, I carry myself with an air of self-assuredness and intelligence. I live in New York City, where I'm carving a path in the fashion industry as a designer, digital artist, and brand consultant. My true passion lies in the arts, cultural events, and community engagement. I relish the blend of creativity and business and thoroughly enjoy weekends spent exploring galleries, attending fashion shows, and actively contributing to local charities and workshops.",
    category: 'Comedy,LGBTQ+,Music',
    gender: 'Female',
    fullName: 'Nia Parker',
    city: 'Dallas',
    status: 'connected',
    platform: {
      instagram: {
        handle: 'niaparker',
        followersCount: 1100000,
      },
      tiktok: {
        handle: 'niaparker',
        followersCount: 6800000,
      },
    },
    contentAgencyMockPost: [
      'https://framerusercontent.com/images/LVu53mpiVFRxh6TEMge7PRxVBGs.jpg',
      'https://framerusercontent.com/images/6Q76PUpcjWsGnP8Yg2lBQxrm6xE.jpg',
      'https://framerusercontent.com/images/qc1wu6T3YNEZqzTzHDzbwh0RM.jpg?scale-down-to=512',
      'https://framerusercontent.com/images/TTmJRZoeVkFvSCgEDzjMoMh2rYM.jpg?scale-down-to=512',
      'https://framerusercontent.com/images/ztV2SEFP6DuoiuoclInzIciu0.jpg',
      'https://framerusercontent.com/images/CxV6sxtzw05vSob5dJBCMpwCrI.jpg?scale-down-to=512',
      'https://framerusercontent.com/images/6RyjqC2TJ6hz2dk52mJ3Vf1CNfM.jpg',
    ],
  },
  {
    age: 29,
    avatar:
      'https://user-assets.dev.usefoam.com/c428078d-58c3-4641-97eb-e5ffd36742dc/creator-logo/blob-66864a51c83077-53265938.png',
    bio: 'Residing in the vibrant city of Atlanta, I consider myself a successful blogger and entrepreneur, using my platform to advocate for body positivity and inclusivity. My interests are largely fashion, wellness, and advocating for social causes. I am also passionate about music, dance, collecting retro tech and playing vinyl records. I enjoy good food shared with friends family. My weekends are spent exploring new cultural experiences and participating in community events that celebrate diversity.',
    category: 'Beauty,Art,Fashion',
    gender: 'Non Binary',
    fullName: 'Olivia Grant',
    city: 'Atlanta',
    status: 'connected',
    platform: {
      instagram: {
        handle: 'oliviagrant',
        followersCount: 26400,
      },
      tiktok: {
        handle: 'oliviagrant',
        followersCount: 128800,
      },
    },
    contentAgencyMockPost: [
      'https://framerusercontent.com/images/XJwHALfyAopdAc7sFA6adOrIig.jpg?scale-down-to=1024',
      'https://framerusercontent.com/images/GkNo2PZhNpCuvjvY8y0geELSQTM.jpg',
      'https://framerusercontent.com/images/5OB4wM3RelfpxgihOd8qsxq6eI.jpg',
      'https://framerusercontent.com/images/4ssobDo7PB4kcM6GIytnd6bl5cU.jpg?scale-down-to=1024',
      'https://framerusercontent.com/images/dKFTs84Bn6tMAzfXBnOx6OZXUE.jpg?scale-down-to=512',
      'https://framerusercontent.com/images/XIyWeVHZRMtqA2LcLYc57EEcPs.jpg?scale-down-to=1024',
      'https://framerusercontent.com/images/QV5Idy5dsRY8baqerrKmV3sfvI.jpg?scale-down-to=512',
    ],
  },
  {
    age: 34,
    avatar:
      'https://user-assets.dev.usefoam.com/07c5b13f-6814-4731-a16a-0bfbb471ea97/creator-logo/blob-6686397eb98dc1-88408644.png',
    bio: "Raymond calls the heart of Chicago home, where he operates a thriving community fitness center that also serves as a youth mentoring program. His passion lies in community development and wellness, and he dedicates his time to advocating for health education, orchestrating local sports events, and hosting inspirational workshops for young individuals. When he's not deeply engaged in his community work, Raymond finds solace in taking long walks through the bustling city streets and indulging in the diverse and vibrant Chicago food scene.",
    category: 'Comedy,Lifestyle,Food',
    gender: 'Male',
    fullName: 'Raymond Porter',
    city: 'Chicago',
    status: 'connected',
    platform: {
      instagram: {
        handle: 'raymondporter',
        followersCount: 13000000,
      },
      tiktok: {
        handle: 'raymondporter',
        followersCount: 5200000,
      },
      youtube: {
        followersCount: 84900,
        handle: 'raymondporter',
      },
      snapchat: {
        handle: 'raymondporter',
        followersCount: 184900,
      },
    },
    contentAgencyMockPost: [
      'https://framerusercontent.com/images/5c0yP4OLGjwpbkkAOAa8sFhQUZs.jpg',
      'https://framerusercontent.com/images/sT6LQTuXWCLzlGEy0wyPc9FtLmA.jpg',
      'https://framerusercontent.com/images/DVOhYcSUZbZ31nPHdEyJlMGs9o.jpg?scale-down-to=512',
      'https://framerusercontent.com/images/5VP1Mm60XL9bCj42GuhjdsjnQ.jpg?scale-down-to=1024',
      'https://framerusercontent.com/images/L4Mr2g84PP0sD6RrqwxbBtiHdE.jpg',
      'https://framerusercontent.com/images/Zp9ylX6AEoH8WWLEPphGcbHIZo.jpg',
      'https://framerusercontent.com/images/xL2nDdqrnByU0Ts7NzgUO7JvOM.jpg?scale-down-to=4096',
    ],
  },
  {
    age: 43,
    avatar:
      'https://user-assets.dev.usefoam.com/a5d6bc14-ee53-4aae-85ec-1f1dbff23b4b/creator-logo/blob-6694db9f962f94-93939612.png',
    bio: "Stefan, a cheerful designer hailing from a charming seaside town in North East England. He enjoys movies and quality family time. Weekends often see him exploring nature or lounging at the beach. His Instagram DIY videos have sparked a passionate following who eagerly await his creative endeavors. Stefan's hands-on approach and innovative ideas have captivated his audience, making him a must-follow for those seeking inspiration. Stay tuned for more from Stefan's exciting journey!",
    category: 'Education,Fitness,Comedy',
    gender: 'Male',
    fullName: 'Stefan Louis',
    city: 'London',
    status: 'connected',
    platform: {
      instagram: {
        handle: 'stefanlouis',
        followersCount: 318800,
      },
      tiktok: {
        handle: 'stefanlouis',
        followersCount: 359300,
      },
      youtube: {
        followersCount: 105800,
        handle: 'stefanlouis',
      },
    },
    contentAgencyMockPost: [
      'https://framerusercontent.com/images/h1XNmLSJVsRfMIhbQ9UBYGxgwNs.jpg',
      'https://framerusercontent.com/images/ASdA6lOizIqfeMtRhMckuyDOuro.jpg?scale-down-to=1024',
      'https://framerusercontent.com/images/NK8SkV1wNMdVbREzhSCQvmxHDJA.jpg?scale-down-to=512',
      'https://framerusercontent.com/images/3NuowqXUVAgxg9n51aznbrr5Es.jpg',
      'https://framerusercontent.com/images/Jy4OQgfzJvQe9ACyVsE0hIcVw.jpg',
      'https://framerusercontent.com/images/qqD6P49PTRKsdX9AtD7eeV4zPU.jpg',
      'https://framerusercontent.com/images/QT2fMymEy4Xhyigwp65tEhBBRQ.jpg?scale-down-to=512',
    ],
  },
];

export const mockCreatorData = createMockCreator(mockCreatorEmptyTalentPage);
